import { EventStatusId } from '../EventStatusId.js'
import { ResultId } from '../ResultId.js'
import { BeachVolleyballResultId } from './BeachVolleyballResultId.js'
import { BeachVolleyballEventStatusId } from './EventStatusId.js'

export const beachVolleyballStatusResultsMap: {
  [key in EventStatusId]?: ResultId[]
} = {
  [BeachVolleyballEventStatusId.FirstSet]: [BeachVolleyballResultId.FirstSet],
  [BeachVolleyballEventStatusId.SecondSet]: [BeachVolleyballResultId.SecondSet],
  [BeachVolleyballEventStatusId.ThirdSet]: [BeachVolleyballResultId.ThirdSet],
  [BeachVolleyballEventStatusId.GoldenSet]: [BeachVolleyballResultId.GoldenSet],
}
